import { Head } from "@inertiajs/react"

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import AuthLayout from "@/layouts/auth-layout"

interface UnknownSubdomainProps {
  subdomain: string
}

export default function UnknownSubdomain({ subdomain }: UnknownSubdomainProps) {
  return (
    <AuthLayout title="" description="">
      <Head title="Workspace not found" />
      <div className="flex w-full flex-col gap-6">
        <Card>
          <CardHeader className="text-center">
            <CardTitle className="text-xl">Workspace not found</CardTitle>
            <CardDescription>
              <span className="font-medium">{subdomain}</span> isn&rsquo;t a
              recognized Imperative workspace. Check the URL with your partner,
              or visit the main Imperative site.
            </CardDescription>
          </CardHeader>
          <CardContent />
        </Card>
      </div>
    </AuthLayout>
  )
}
